import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Alert, CircularProgress
} from '@mui/material';
import { authService } from '../../services/authService';

export default function RevokeConfirmDialog({ open, onClose, assignment, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleRevoke = async () => {
    if (!assignment) return;
    setLoading(true);
    setError(null);
    try {
      await authService.revokeAssignment(assignment.assignment_id);
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error?.message || err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Revoke Role Assignment</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{typeof error === 'string' ? error : error?.message || JSON.stringify(error)}</Alert>}
        <Typography>
          Are you sure you want to revoke the <strong>{assignment?.role?.role_name}</strong> role
          {assignment?.org_entity_id ? ` (scoped to ${assignment.org_entity_id})` : ''}?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone. The user will immediately lose the associated permissions.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button onClick={handleRevoke} color="error" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={20} /> : 'Revoke'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
